import { gql } from 'apollo-boost';

export const SEND_PUSH_CAMPAIGN = gql`
    mutation($data: SendPushCampaignInput!) {
        sendPushCampaign(data: $data) {
            ... on SendPushCampaignSuccess {
                success
                notificationsSent
                totalUsers
                campaignId
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
